import { uiText, useUiLanguage } from '@/i18n/interface';
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Bell, Calendar, Award, AlertCircle } from 'lucide-react';

interface NotificationPopupProps {
  notification: {
    id: string;
    type: string;
    title: string;
    message: string;
    created_at: string;
  } | null;
  open: boolean;
  onClose: () => void;
  onMarkAsRead: (id: string) => void;
}

const NotificationPopup: React.FC<NotificationPopupProps> = ({
  notification,
  open,
  onClose,
  onMarkAsRead
}) => {
  useUiLanguage();
  if (!notification) return null;

  const getNotificationIcon = (type: string) => {
    switch (type) {
      case 'training':
        return <Calendar className="h-6 w-6 text-blue-500" />;
      case 'promotion':
        return <Award className="h-6 w-6 text-yellow-500" />;
      case 'announcement':
        return <Bell className="h-6 w-6 text-green-500" />;
      default:
        return <AlertCircle className="h-6 w-6 text-gray-500" />;
    }
  };

  const handleMarkAsReadAndClose = () => {
    onMarkAsRead(notification.id);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3">
            {getNotificationIcon(notification.type)}
            {uiText("New Notification")}</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-lg">{notification.title}</h3>
            <p className="text-muted-foreground mt-2">{notification.message}</p>
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose}>
              {uiText("Close")}</Button>
            <Button onClick={handleMarkAsReadAndClose}>
              {uiText("Mark as Read")}</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default NotificationPopup;